import { useQuery } from '@hooks/reactQuery';

import { getConfigurationTemplateUsers } from '@api/configurationTemplates';

import { mapDropdownOptions } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONFIGURATION_TEMPLATES_USERS } from '@constants/queryKeys';

interface IUseQueryConfigurationTemplatesUsers {
	configurationTemplateUsers: TSelectOption<string>[];
	isLoadingConfigurationTemplateUsers: boolean;
}

const useQueryConfigurationTemplatesUsers = (): IUseQueryConfigurationTemplatesUsers => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [CONFIGURATION_TEMPLATES_USERS],
		queryFn: getConfigurationTemplateUsers,
		select: (data) => mapDropdownOptions({
			items: data,
			valueKey: 'id',
			labelKey: 'name',
		}),
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		configurationTemplateUsers: data || [],
		isLoadingConfigurationTemplateUsers: (!!data && isLoading) || isFetching,
	};
};

export default useQueryConfigurationTemplatesUsers;
